import publicApis from './public'

export default {
  public: publicApis
}
